import { type Config, getConfig } from '@utils/config.svelte'
import { getCanonicalActiveProducts, Product } from '@utils/product'

const EVALUATION_CONFIG_LOADING_MESSAGE = 'Loading evaluation configuration...'
const EVALUATION_CONFIG_ERROR_MESSAGE = 'Failed to load evaluation configuration.'
const EVALUATION_DISABLED_MESSAGE = 'Evaluation is not enabled for this deployment.'

class EvaluationEntitlementState {
  config = $state<Config | null>(null)
  loaded = $state(false)
  loadError = $state(false)
  enabled = $derived(
    Boolean(
      (
        this.config?.activeProducts ??
        getCanonicalActiveProducts(this.config?.activeProductEntitlements)
      ).includes(Product.LLM_BEHAVIOR_EVAL),
    ),
  )
  status = $derived(
    this.loadError ? 'error' : !this.loaded ? 'loading' : this.enabled ? 'enabled' : 'disabled',
  )

  async load() {
    this.loadError = false
    try {
      this.config = await getConfig()
    } catch {
      this.loadError = true
    } finally {
      this.loaded = true
    }
    return this.config
  }
}

export {
  EVALUATION_CONFIG_ERROR_MESSAGE,
  EVALUATION_CONFIG_LOADING_MESSAGE,
  EVALUATION_DISABLED_MESSAGE,
  EvaluationEntitlementState,
}
